export const isRumEnabledForCompany = (
  datadogEnvironment: string,
  allowedCompanyIds: number[],
  companyId: number | undefined
): boolean => {
  if (datadogEnvironment.startsWith('demo')) {
    return true
  }

  if (!companyId) {
    return false
  }

  return allowedCompanyIds.includes(companyId)
}
